export class MustBeOverridenError extends Error {}

export class ValidationError extends Error {}

export class ArgumentError extends Error {}

const MIN_CODE_ERROR_REDIRECT = 300;
const MIN_CODE_ERROR_USER = 400;
const MIN_CODE_ERROR_SERVEUR = 500;

/**
 * Extends error to be able to keep external data
 */
export class RequestError extends Error {
	constructor(message, url, code, response) {
		super(message);
		this._message = message;
		this._url = url;
		this._code = code;
		this._response = response;
		this._name = this.constructor.name;
	}

	toString() {
		return `[Fetch] Could not fetch ${this._url} (${this._code}):\n${
			this._response
		}\n${this.stack}`;
	}

	/**
	 * Retrieve the status of the request
	 * @return {String} - The status code
	 */
	getStatus() {
		return this._code;
	}

	hasError() {
		return Boolean(this._code >= MIN_CODE_ERROR_REDIRECT);
	}

	isRedirectError() {
		return Boolean(
			this._code >= MIN_CODE_ERROR_REDIRECT &&
				this._code < MIN_CODE_ERROR_USER
		);
	}

	isUserError() {
		return Boolean(
			this._code >= MIN_CODE_ERROR_USER &&
				this._code < MIN_CODE_ERROR_SERVEUR
		);
	}

	isServerError() {
		return Boolean(this._code >= MIN_CODE_ERROR_SERVEUR);
	}
}
